import { httpClient } from "./client";
import type { CoachingApi } from "./coachingContracts";

const request = (id: string) => `/lesson-requests/${encodeURIComponent(id)}`;
const acceptance = (id: string) => `/lesson-requests/acceptances/${encodeURIComponent(id)}`;
const page = (params: { limit?: number; offset?: number } = {}) => {
  const search = new URLSearchParams();
  if (params.limit !== undefined) search.set("limit", String(params.limit));
  if (params.offset !== undefined) search.set("offset", String(params.offset));
  return search.size ? `?${search}` : "";
};
export const coachingApi: CoachingApi = {
  getInquiryContext: (id, signal) => httpClient.get(`/lesson-requests/inquiries/${encodeURIComponent(id)}`, { signal }),
  createFromInquiry: (id, body) => httpClient.post(`/lesson-requests/inquiries/${encodeURIComponent(id)}`, body),
  listInquiryOffers: (id, params, signal) => {
    const search = new URLSearchParams();
    if (params?.limit !== undefined) search.set("limit", String(params.limit));
    if (params?.cursor) search.set("cursor", params.cursor);
    return httpClient.get(`/lesson-requests/inquiries/${encodeURIComponent(id)}/offers${search.size ? `?${search}` : ""}`, { signal });
  },
  getInquiryOffer: (id, revisionId, signal) => httpClient.get(
    `/lesson-requests/inquiries/${encodeURIComponent(id)}/offers/${encodeURIComponent(revisionId)}`, { signal }),
  listGuardianInvitations: (params, signal) => httpClient.get(`/lesson-requests/guardian-invitations${page(params)}`, { signal }),
  createGuardianInvitation: (id, body) => httpClient.post(`${request(id)}/guardian-invitations`, body),
  acceptGuardianInvitation: (id) => httpClient.post(`/lesson-requests/guardian-invitations/${encodeURIComponent(id)}/accept`),
  revokeGuardianInvitation: (id) => httpClient.post(`/lesson-requests/guardian-invitations/${encodeURIComponent(id)}/revoke`),
  listWorkspace: (params, signal) => httpClient.get(`/lesson-requests/workspace${page(params)}`, { signal }),
  getWorkspace: (id, signal) => httpClient.get(`${request(id)}/workspace`, { signal }),
  getAmendmentContext: (id, acceptanceId, signal) => httpClient.get(
    `${request(id)}/acceptances/${encodeURIComponent(acceptanceId)}/amendment-context`, { signal }),
  previewAvailability: (id, query, signal) => {
    const search = new URLSearchParams({ start_on: query.start_on,
      days: String(query.days ?? 1), duration_minutes: String(query.duration_minutes ?? 60) });
    if (query.court_id) search.set("court_id", query.court_id);
    return httpClient.get(`${request(id)}/availability?${search}`, { signal });
  },
  checkAvailability: (id, body, signal) => httpClient.post(`${request(id)}/availability/check`, body, { signal }),
  listProposals: (id, signal) => httpClient.get(`${request(id)}/proposals`, { signal }),
  getProposal: (id, revision, signal) => httpClient.get(`${request(id)}/proposals/${encodeURIComponent(revision)}`, { signal }),
  issueProposal: (id, body) => httpClient.post(`${request(id)}/proposals`, body),
  decideProposal: (id, body) => httpClient.post(`${request(id)}/decisions`, body),
  acceptProposal: (id, body) => httpClient.post(`${request(id)}/accept`, body),
  getLesson: (id, signal) => httpClient.get(`${acceptance(id)}/lesson`, { signal }),
  bookCredit: (id, body) => httpClient.post(`${acceptance(id)}/credits/book`, body),
  recordSessionOutcome: (id, sessionId, body) => httpClient.post(
    `${acceptance(id)}/sessions/${encodeURIComponent(sessionId)}/outcome`, body),
  createCancellationQuote: (id, body) => httpClient.post(`${acceptance(id)}/cancellation-quotes`, body),
  confirmCancellation: (id, body) => httpClient.post(`${acceptance(id)}/cancellations`, body),
  getCancellation: (id, commandId, signal) => httpClient.get(`${acceptance(id)}/cancellations/${encodeURIComponent(commandId)}`, { signal }),
  listCancellations: (id, signal) => httpClient.get(`${acceptance(id)}/cancellations`, { signal }),
  reconcileCancellation: (id, commandId) => httpClient.post(`${acceptance(id)}/cancellations/${encodeURIComponent(commandId)}/reconcile`),
  listPayments: (params, signal) => httpClient.get(`/lesson-requests/payments${page(params)}`, { signal }),
  getPayment: (id, signal) => httpClient.get(`${acceptance(id)}/payment`, { signal }),
  fund: (id, body) => httpClient.post(`${acceptance(id)}/fund`, body),
  reconcile: (id) => httpClient.post(`${acceptance(id)}/reconcile`),
};
